// Stub module — re-exports the new Button from the primitives barrel.
// Older imports `import { Button } from "@/components/ui/button"`
// keep compiling while pages are migrated.

import { Button as _Button, type ButtonHTMLAttributes } from './ApplePrimitives';

export const Button = _Button;

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;